(function () {
  // Respektiere Nutzer, die Animationen deaktivieren
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initSnow() {
    // Doppelte Einbindung verhindern
    if (document.getElementById('mb-snow-container')) return;

    const snowContainer = document.createElement('div');
    snowContainer.id = 'mb-snow-container';
    snowContainer.style.position = 'fixed';
    snowContainer.style.top = 0;
    snowContainer.style.left = 0;
    snowContainer.style.width = '100%';
    snowContainer.style.height = '100%';
    snowContainer.style.pointerEvents = 'none';
    snowContainer.style.overflow = 'hidden';
    snowContainer.style.zIndex = 999999; // sehr hoch, aber überlagert keine klicks
    document.body.appendChild(snowContainer);

    // Styles + Keyframes einmalig injizieren
    const style = document.createElement('style');
    style.id = 'mb-snow-style';
    style.textContent = `
      @keyframes mb-fall {
        0% { transform: translate3d(var(--x,0), -10%, 0) rotate(0deg); }
        100% { transform: translate3d(var(--x,0), 110vh, 0) rotate(360deg); }
      }
      .mb-snowflake {
        position: absolute;
        top: -10%;
        will-change: transform, opacity;
        color: #fff;
        opacity: .9;
        filter: drop-shadow(0 0 2px rgba(255,255,255,.7));
      }
    `;
    document.head.appendChild(style);

    function createSnowflake() {
      const s = document.createElement('div');
      s.className = 'mb-snowflake';
      // 20% echte ❄, 80% Punkt – performanter
      s.textContent = Math.random() < 0.2 ? '❄' : '•';
      const size = 8 + Math.random() * 14;           // 8–22px
      const startLeft = Math.random() * 100;          // 0–100%
      const drift = (Math.random() * 40 - 20) + 'vw'; // -20vw bis +20vw
      const duration = 7 + Math.random() * 10;        // 7–17s
      const delay = Math.random() * 2;                // 0–2s

      s.style.fontSize = size + 'px';
      s.style.left = startLeft + 'vw';
      s.style.setProperty('--x', drift);
      s.style.animation = `mb-fall ${duration}s linear ${delay}s forwards`;

      // leichte Variation
      s.style.opacity = (0.6 + Math.random() * 0.4).toString();

      snowContainer.appendChild(s);
      // Aufräumen
      setTimeout(() => s.remove(), (duration + delay) * 1000 + 200);
    }

    // Frequenz: je kleiner, desto mehr Schnee (ms)
    const intervalMs = 180;
    const spawn = setInterval(createSnowflake, intervalMs);

    // Beim Theme-Wechsel / Turbolinks etc. aufräumen
    document.addEventListener('pagehide', () => {
      clearInterval(spawn);
      snowContainer.remove();
      const st = document.getElementById('mb-snow-style');
      if (st) st.remove();
    });
  }

  // Aufruf nach DOM bereit (auch in AJAX-Navigation stabil)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSnow);
  } else {
    initSnow();
  }
})();
